// NPM Imports
import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { Toastr, Tooltip } from "@revvsales/components";

// Components Imports
import { Dropdown } from "../../../commonComponents";
import PipelineFilterPopup from "../PipelineFilterPopup";
// import TitleBar from "../../TitleBar";

// Actions Imports
import PipelineActions from "../../../actions/PipelineActions";

// Internal Imports
import { PIPELINE } from "../../../constants";
import { GlobalUtils, OppoUtils } from "../../../utils";

// Destructuring
const { filterPipelineData } = PipelineActions;
const { BY_DATE, BY_STAGES, BY_OWNER, BY_ACCOUNT } = PIPELINE;
const {
  handleApiErrMsg,
  readDataFromLocalStorage,
  writeDataToLocalStorage,
} = GlobalUtils;
const { sortAccountsByAZ } = OppoUtils;

class PipelineOpportunityFilter extends Component {
  dropdownRef = React.createRef();

  state = {
    accountFilter: "",
    ownerFilters: [],
    dateFilterType: "None",
    customDateFilter: false,
    customStartDate: moment().format("YYYY-MM-DD"),
    customEndDate: moment().format("YYYY-MM-DD"),
    stageFilters: [],
    filters: [],
    showFilterPopup: false,
    showSortOppsPopup: false,
    showFilterBtnLoader: false,
  };

  _updateState = (key, value) => {
    this.setState({ [key]: value });
  };

  _setAccountFilter = account => {
    this.setState({ accountFilter: account });
  };

  _setDateFilterType = dateFilterType => {
    if (dateFilterType === "Custom") {
      this.setState({ customDateFilter: true });
    } else {
      let startDate;
      let endDate;
      this.setState({ customDateFilter: false });

      if (dateFilterType === "None") {
        startDate = moment().format("YYYY-MM-DD");
        endDate = moment().format("YYYY-MM-DD");
      }
      if (dateFilterType === "Past 1 Month") {
        startDate = moment()
          .subtract(1, "months")
          .format("YYYY-MM-DD");
        endDate = moment().format("YYYY-MM-DD");
      }
      if (dateFilterType === "Past 2 Months") {
        startDate = moment()
          .subtract(2, "months")
          .format("YYYY-MM-DD");
        endDate = moment().format("YYYY-MM-DD");
      }
      if (dateFilterType === "Past 6 Months") {
        startDate = moment()
          .subtract(6, "months")
          .format("YYYY-MM-DD");
        endDate = moment().format("YYYY-MM-DD");
      }
      this.setState({ customStartDate: startDate, customEndDate: endDate });
    }
    this.setState({ dateFilterType });
  };

  _setOppoStagesFilters = stage => {
    const { stageFilters } = this.state;
    const currentStages = [...stageFilters];
    if (stageFilters.includes(stage)) {
      let newStages;
      const index = stageFilters.indexOf(stage);
      if (index > -1) {
        newStages = [
          ...currentStages.slice(0, index),
          ...currentStages.slice(index + 1, currentStages.length),
        ];
        this.setState({ stageFilters: newStages });
      }
    } else {
      this.setState({ stageFilters: [...currentStages, stage] });
    }
  };

  _filterPipelineDataHandler = filters => {
    this.setState({ filters, showFilterBtnLoader: true });
    this.props
      .filterPipelineData(filters, this.props.accounts)
      .then(() => {
        // Clear the select opportunity from the localStorage
        const user = readDataFromLocalStorage("revvsalesUser");
        delete user.opportunityFilter;
        writeDataToLocalStorage("revvsalesUser", user);

        this.setState({ showFilterBtnLoader: false, showFilterPopup: false });
        this.props.updateMultiplePipelineState({
          searchTerm: "",
          currentSelectedOpp: "",
        });
      })
      .catch(error => {
        this.setState({ showFilterBtnLoader: false });
        Toastr.showToastr({
          type: "failure",
          message: handleApiErrMsg(error),
          timeout: 3000,
        });
      });
  };

  _submitFilters = () => {
    const {
      accountFilter,
      ownerFilters,
      dateFilterType,
      customStartDate,
      customEndDate,
      stageFilters,
    } = this.state;
    const filters = [];

    if (accountFilter.value) {
      const filterObj = {};
      filterObj.name = BY_ACCOUNT;
      filterObj.accountId = accountFilter.value;
      filters.push(filterObj);
    }
    if (ownerFilters.length > 0) {
      const filterObj = {};
      filterObj.name = BY_OWNER;
      filterObj.owners = ownerFilters;
      filters.push(filterObj);
    }
    if (dateFilterType !== "None") {
      const filterObj = {};
      filterObj.name = BY_DATE;
      filterObj.startDate = customStartDate;
      filterObj.endDate = customEndDate;
      filters.push(filterObj);
    }
    if (stageFilters.length > 0) {
      const filterObj = {};
      filterObj.name = BY_STAGES;
      filterObj.stages = stageFilters;
      filters.push(filterObj);
    }
    this._filterPipelineDataHandler(filters);
  };

  _clearFilters = filterType => {
    switch (filterType) {
      case 1:
        this.setState({ accountFilter: "" });
        break;
      case 2:
        this.setState({ ownerFilters: [] });
        break;
      case 3:
        this.setState({ dateFilterType: "None", customDateFilter: false });
        break;
      case 4:
        this.setState({ stageFilters: [] });
        break;
      case 5:
        this.setState({
          accountFilter: "",
          ownerFilters: [],
          dateFilterType: "None",
          customDateFilter: false,
          stageFilters: [],
        });
        this._filterPipelineDataHandler([]);
        break;
      default:
        break;
    }
  };

  // ceate options for sort Dropdown
  _sortDropDownOptions = (sortByOpp, updateSortBy) => ({
    icon: "sort-amount-up",
    position: "bottom",
    title: "Sort By",
    selectedClassNameIdent: sortByOpp,
    className: "pipelineleftfilter-delete-dropdown",
    options: [
      {
        name: "Last Updated",
        argument: "lastUpdate",
        icon: "",
        action: updateSortBy,
      },
      {
        name: "Date Created",
        argument: "dateCreated",
        icon: "",
        action: updateSortBy,
      },
      {
        name: "A - Z",
        argument: "A_Z",
        icon: "",
        action: updateSortBy,
      },
    ],
  });

  _setSearchTerm = e => {
    this.props.updatePipelineState("searchTerm", e.target.value);
  };

  _clearSearch = () => {
    this.props.updatePipelineState("searchTerm", "");
  };

  _openFilterPopup = () => {
    this.setState({ showFilterPopup: true });
  };

  _closeFilterPopup = () => {
    this.setState({ showFilterPopup: false });
  };

  // toggle "showSortOppsPopup" when click on sort opportunities button
  _toggleSortOppsPopup = () => {
    // attach/remove event handler
    if (!this.state.showSortOppsPopup) {
      document.addEventListener(
        "click",
        this._handleDropdownOutsideClick,
        false,
      );
    } else {
      document.removeEventListener(
        "click",
        this._handleDropdownOutsideClick,
        false,
      );
    }

    this.setState(prevState => ({
      showSortOppsPopup: !prevState.showSortOppsPopup,
    }));
  };

  _handleDropdownOutsideClick = e => {
    const node = this.dropdownRef.current;
    // ignore clicks on the component itself
    if (node && node.contains(e.target)) {
      return;
    }
    this._toggleSortOppsPopup();
  };

  render() {
    return (
      <Fragment>
        {/* ------- Opportunity Filter Popup ---------- */}
        {this.state.showFilterPopup && (
          <PipelineFilterPopup
            show={this.state.showFilterPopup}
            showFilterBtnLoader={this.state.showFilterBtnLoader}
            // filter data
            accountFilter={this.state.accountFilter}
            accountList={sortAccountsByAZ(this.props.accounts)}
            ownerFilters={this.state.ownerFilters}
            dateFilterType={this.state.dateFilterType}
            customDateFilter={this.state.customDateFilter}
            customStartDate={this.state.customStartDate}
            customEndDate={this.state.customEndDate}
            oppoStages={this.props.opportunityStages}
            filters={this.state.filters}
            stageFilters={this.state.stageFilters}
            // filter handlers
            setAccountFilter={this._setAccountFilter}
            setDateFilterType={this._setDateFilterType}
            setOppoStagesFilters={this._setOppoStagesFilters}
            submitFilters={this._submitFilters}
            updateState={this._updateState}
            clearFilters={this._clearFilters}
            closePopup={this._closeFilterPopup}
          />
        )}
        <div className="search-opp-wrapper">
          <div className="search-opp-title-wrapper">
            {/* ------- Search Opportunity Box ---------- */}
            <span className="search-opp-search-wrapper">
              <span
                className="pipelineheader-search-icon"
                data-test="pipelineopportunityfilter-search-icon">
                <FontAwesomeIcon icon={["far", "search"]} />
              </span>
              <input
                data-test="pipelineopportunityfilter-opportunity-search-inputfield"
                className="formcontrol pipelineheader-search"
                type="text"
                placeholder="Search Opportunities.."
                value={this.props.searchTerm}
                onChange={this._setSearchTerm}
                onClick={
                  this.props.currentSelectedOpp
                    ? this.props.clearPipelineSelection
                    : () => {}
                }
              />
              <span
                className={`pipelineheader-clear-searchbtn ${
                  this.props.searchTerm.length === 0 ? "hide-item" : ""
                }`}
                onClick={this._clearSearch}
                onKeyPress={this._clearSearch}
                role="button"
                tabIndex="0">
                <FontAwesomeIcon icon={["far", "times-circle"]} />
              </span>
            </span>
            {/* ------- Sort Opportunity Button ---------- */}
            <Tooltip
              placement="left"
              overlay="Sort Opportunities"
              align={{
                offset: [3, 0],
              }}>
              <div className="pipelineheader-sort-dropdown">
                <Dropdown
                  options={this._sortDropDownOptions(
                    this.props.sortByOpp,
                    this.props.updateSortBy,
                  )}
                  showDropdown={this.state.showSortOppsPopup}
                  showDropdownHandler={this._toggleSortOppsPopup}
                  dropdownRef={this.dropdownRef}
                />
              </div>
            </Tooltip>
            {/* ------- Filter Opportunity Button ---------- */}

            <span
              className={`pipelineheader-filterbtn-wrapper ${
                this.state.filters.length === 0
                  ? "pipelineheader-clear-filterbtn"
                  : ""
              }`}>
              {this.state.showFilterBtnLoader && (
                <span className="pipelineheader-filterbtn-loader">
                  <i className="pipelineheader-filterbtn-loadericon">
                    <FontAwesomeIcon
                      icon={["far", "spinner"]}
                      className="fa-spin"
                    />
                  </i>
                </span>
              )}
              <span
                data-test="pipelineopportunityfilter-opprtunity-filter-icon"
                className="pipelineheader-filterbtn"
                onClick={this._openFilterPopup}
                onKeyPress={this._openFilterPopup}
                role="button"
                tabIndex="0">
                <FontAwesomeIcon icon={["far", "filter"]} />
                <span className="pipelineheader-filter-count">
                  {this.state.filters.length}
                </span>
              </span>
              <span
                className="pipelineheader-filter-clearicon"
                onClick={() => this._clearFilters(5)}
                onKeyPress={() => {}}
                role="button"
                tabIndex="-1">
                <FontAwesomeIcon icon={["far", "times"]} />
              </span>
            </span>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  const { opportunityStages, accounts } = state.PipelineStore;
  return {
    opportunityStages,
    accounts,
  };
};

const mapDispatchToProps = {
  filterPipelineData: (filters, accounts) =>
    filterPipelineData(filters, accounts),
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PipelineOpportunityFilter);



// WEBPACK FOOTER //
// ./src/components/PipelineWrapper/PipelineOpportunityFilter/index.js